import { render } from "./TournamentModal.vue?vue&type=template&id=6b09a2f4&scoped=true&ts=true"
import script from "./TournamentModal.vue?vue&type=script&lang=ts"
export * from "./TournamentModal.vue?vue&type=script&lang=ts"

import "./TournamentModal.vue?vue&type=style&index=0&id=6b09a2f4&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b09a2f4"]])

export default __exports__